export default __webpack_public_path__ + "media/images/credit_card_blue-f448a8367efc753da9c4157c640aed55.png";